module.exports = __webpack_public_path__ + "static/media/bet-logo-toto.e3b0368a.png";